"use client";

import { useState } from "react";
import CouponGridCard from "./CouponGridCard";

interface CompetitorCouponsProps {
    /** A REFERRAL store's page (lib/page-type): the heading says referral codes. */
    referral?: boolean;
    coupons: any[];
    currentStoreName: string;
    categoryName?: string;
}

export default function CompetitorCoupons({ coupons, currentStoreName, categoryName, referral = false }: CompetitorCouponsProps) {
    const [visibleCount, setVisibleCount] = useState(6);

    if (coupons.length === 0) return null;

    const visibleCoupons = coupons.slice(0, visibleCount);
    const hasMore = coupons.length > visibleCount;

    return (
        <section className="mt-16 space-y-8" aria-labelledby="similar-offers-title">
            <div className="cs-reading relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 p-12 opacity-5 pointer-events-none">
                    <svg className="w-64 h-64 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
                </div>

                <h2 id="similar-offers-title" className="text-2xl font-bold text-white mb-3 relative z-10">
                    Similar <span className="text-[#00ff9d]">{categoryName || "Store"}</span> {referral ? "Referral Codes" : "Coupons"}
                </h2>
                <p className="text-gray-400 max-w-3xl relative z-10">
                    Valid discounts from brands similar to {currentStoreName}.
                </p>
            </div>

            <div className="cs-offer-grid">
                {visibleCoupons.map((coupon) => (
                    <CouponGridCard
                        key={coupon.id}
                        id={coupon.id}
                        title={coupon.title}
                        code={coupon.code || ""}
                        description={coupon.description || ""}
                        storeName={coupon.store?.name || "Competitor"}
                        storeSlug={coupon.store?.slug || ""}
                        storeId={coupon.store?.id || ""}
                        affiliateLink={coupon.store?.affiliateLink || "#"}
                        storeLogo={coupon.store?.logo}
                        type={coupon.type}
                        verified={coupon.verified}
                        successRate={coupon.successRate}
                        discountValue={coupon.discountValue}
                        discountType={coupon.discountType}
                        anchorSuffix={coupon.store?.anchorSuffix}
                    />
                ))}
            </div>

            {hasMore && (
                <div className="text-center">
                    <button
                        onClick={() => setVisibleCount(prev => prev + 6)}
                        className="cs-btn"
                    >
                        Load More Competitors
                    </button>
                </div>
            )}
        </section>
    );
}
